// extracted by mini-css-extract-plugin
export default {"fieldset":"YbWHN3M9urMFMbxPtoY5","legend":"yuGOsFtDxqn7SvxBUJcU","loader":"ld27e_OIKmyXtcEGJpU3","description":"Pv4psDJhrKqkrRgQIGkG","placeHolderShimmer":"hTeRe20vvv2nUQWdQ7LJ"};